module.exports = __webpack_public_path__ + "img/ssl_rapid_secured.1931d61a.gif";